import React, { useEffect, useState } from "react";
import { Toolbar, Typography } from "@mui/material";
import TableRowsLoader from "../../../components/common/Loader/tableLoader";
import { ClientType } from "../../../types/genericType";
import { getAllClients } from "../../../services/clientService";
import ClientsTable from "../../../components/clientsTable/ClientsTable";
import NewClientDrawer from "../../../components/clientDrawer/NewClientDrawer";
import { useSelector, useDispatch } from "react-redux";
import "./styles.scss";
import { setSelectedClient } from "../../../redux/features/clientSlice";

const Clients = () => {
  const [clientsData, setClientsData] = useState<ClientType[]>([]);
  const [openEditDrawer, setOpenEditDrawer] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { selectedClient } = useSelector((state: any) => state.clientState);
  const dispatch = useDispatch();

  const updateSelectedClient = (client: ClientType) => {
    dispatch(setSelectedClient(client));
  };

  const getClientsData = () => {
    setIsLoading(true);
    getAllClients()
      .then((res) => {
        setIsLoading(false);

        //replace null last name with blank string
        let sortedData = res.filter(client=>{
          if(client.lastName === null){
            client.lastName = "";
          }
          return client;
        }).sort((a, b) => {
          // First, sort by active status (active first)
          if (a.isActive !== b.isActive) {
            return a.isActive ? -1 : 1;
          }

          //Then, sort by last name or company name
          const nameA = a.lastName || a.companyName || "";
          const nameB = b.lastName || b.companyName || "";
          return nameA.localeCompare(nameB);
        });

        setClientsData(sortedData);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getClientsData();
  }, []);

  return (
    <>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Typography className="title">Clients</Typography>
        <NewClientDrawer
          getClientsData={getClientsData}
          selectedClient={selectedClient}
          updateSelectedClient={updateSelectedClient}
          openEditDrawer={openEditDrawer}
          setOpenEditDrawer={setOpenEditDrawer}
        />
      </Toolbar>
      {!isLoading ? (
        <ClientsTable
          data={clientsData}
          selectedClient={selectedClient}
          updateSelectedClient={updateSelectedClient}
          setOpenEditDrawer={setOpenEditDrawer}
        />
      ) : (
        <TableRowsLoader rowsNum={10} />
      )}
    </>
  );
};

export default Clients;
